/** Parse display / ecommerce money into a finite number, or undefined. */
export function parseMoney(value: unknown): number | undefined {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  if (!trimmed) return undefined;

  // Prefer last comma/dot as decimal when both appear (EU vs US formats).
  const normalized = trimmed
    .replace(/[^\d.,\-]/g, '')
    .replace(/(\d)[.,](?=\d{3}(?:[.,]|$))/g, '$1')
    .replace(/,/g, '.');

  const parsed = Number.parseFloat(normalized);
  return Number.isFinite(parsed) ? parsed : undefined;
}

/** Shopify `total_price` is integer cents. */
export function shopifyCentsToValue(cents: unknown): number | undefined {
  if (typeof cents !== 'number' || !Number.isFinite(cents)) return undefined;
  return cents / 100;
}

export function parseItemQuantity(value: unknown): number | undefined {
  if (typeof value === 'number' && Number.isFinite(value) && value >= 0) {
    return Math.floor(value);
  }
  if (typeof value === 'string') {
    const parsed = Number.parseInt(value.trim(), 10);
    if (Number.isFinite(parsed) && parsed >= 0) return parsed;
  }
  return undefined;
}

export function normalizeCurrency(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim().toUpperCase();
  if (!/^[A-Z]{3}$/.test(trimmed)) return undefined;
  return trimmed;
}
